import { Fc27Banner } from "@/components/features/EditionSwitch/Fc27Banner";
import { canonicalUrl } from "@/config/canonical";
import { GAME_NAME } from "@/config/game";
import { HeroSection } from "@/containers/HeroSection";
import { untradeable_icon_true } from "@/icons";
import { AppPromoBanner } from "@/pages/AppLanding/AppPromoBanner";
import { useTranslation } from "@repo/shared/i18n";

import { ForYou } from "./ForYou/ForYou";
import { TrendingOrNewContent } from "./TrendingOrNewContent/TrendingOrNewContent";

const FrontPage = () => {
  const { t } = useTranslation("frontPage");

  return (
    <div className="bg-neutral-900">
      <Fc27Banner variant="compact" />
      <HeroSection
        helmetTitle={t("helmet.title", { game: GAME_NAME })}
        helmetDescription={t("helmet.description", { game: GAME_NAME })}
        helmetCanonicalLink={canonicalUrl("/")}
        shouldBeInTheDocumentFlow={true}
      />
      <div className="mx-auto max-w-content pt-4 mobile:pt-12 pb-16 flex flex-col gap-y-6 mobile:gap-y-12 px-4 large-desktop:px-16">
        <AppPromoBanner />
        <TrendingOrNewContent />
        <ForYou />
      </div>
    </div>
  );
};

export default FrontPage;
